export const SLIDE_DECK_CANVAS = { width: 1920, height: 1080 } as const;
